<template>
  <div class="mb10">
    <form @onsubmit.prevent action>
      <div class="row mb5">
        <div class="col-md-2"></div>
        <div class="col-md-3 text-center">
          <label class="form-control-label text-bold">Change in debt {{isFromComp}}</label>
        </div>
        <div class="col-md-3 text-center">
          <label class="form-control-label text-bold">Investment Made</label>
        </div>
        <div class="col-md-3 text-center">
          <label class="form-control-label text-bold">Equity raised</label>
        </div>
        
      </div>
      <div
        v-for="(field, index) in tableRows"
        v-bind:key="index"
        class="row"
        style="margin-bottom: 10px;"
      >
        <div class="col-md-2">
          <label :for="field.title" class="form-control-label">{{field.name}}</label>
        </div>
        <div class="col col-md-3"
        v-for="(col, ind) in tableColumns"
        v-bind:key="ind"
        >
        <!-- {{fields[ind]+" = " +index +" = "+ col.title}} {{fields[ind]['type']}}  {{col.title+'_'+field.title}} -->
          <input
            :type="fields[ind]['type']"
            v-model.number="formData[col.title+'_'+field.title]"
            :id="fields[ind].name"
            :placeholder="'Enter '+field.title"
            class="form-control"
          >
          <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-11">
          <div class="form-group pull-right">
            <!-- <submitButton @click.prevent="submit" type="submit" class="btn btn-info">Submit</submitButton> -->
            <button @click="save" type="button" class="btn btn-primary">Save</button>
            <button @click="updateData" type="button" class="btn btn-primary">Save & Update</button>
          </div>
        </div>
      </div>
      <PinCheck
        :show.sync="show"
        ref="smallModal"
        v-bind:small="true"
        @submitForm="submitForm"
        :cancelClass="'btn btn-secondary'"
      ></PinCheck>
    </form>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: { PinCheck },
  mixins: [commonMixins],
  props: ["companyData", "isFromComp", "selCompany"],
  created() {},
  data() {
    return {
      show: false,
      curDate: new Date(),
      company: {},
      tableRows: [
        {title: "p1", name: this.getLabel("p1")},
        {title: "p2", name: this.getLabel("p2")},
        {title: "p3", name: this.getLabel("p3")},
        {title: "p4", name: this.getLabel("p4")},
        {title: "p5", name: this.getLabel("p5")},
        {title: "p6", name: this.getLabel("p6")},
        {title: "p7", name: this.getLabel("p7")},
        {title: "p8", name: this.getLabel("p8")},
        {title: "p9", name: this.getLabel("p9")},
        {title: "p10", name: this.getLabel("p10")},
        ],
      tableColumns: [
        {title: "change_in_debt", name: this.getLabel("change_in_debt")},
        {title: "investment_made", name: this.getLabel("investment_made")},
        {title: "equity_raised", name: this.getLabel("equity_raised")},
      ],
      globalData: {
        change_in_debt: {
          p1: "",
          p2: "",
          p3: "",
          p4: "",
          p5: "",
          p6: "",
          p7: "",
          p8: "",
          p9: "",
          p10: ""
        },
        investment_made: {
          p1: "",
          p2: "",
          p3: "",
          p4: "",
          p5: "",
          p6: "",
          p7: "",
          p8: "",
          p9: "",
          p10: ""
        },
        equity_raised: {
          p1: "",
          p2: "",
          p3: "",
          p4: "",
          p5: "",
          p6: "",
          p7: "",
          p8: "",
          p9: "",
          p10: ""
        }
      },
      fields: [
        {
          label: "Change In Debt",
          name: "change_in_debt",
          type: "text",
          reletedField: [
            {
              label: "p1",
              placeholder: "Enter P1 ",
              name: "change_in_debt_p1",
              type: "text",
              value: ""
            },
            {
              label: "p2",
              placeholder: "Enter P2",
              name: "change_in_debt_p2",
              type: "text",
              value: ""
            },
            {
              label: "p3",
              placeholder: "Enter P3",
              name: "change_in_debt_p3",
              type: "text",
              value: ""
            },
            {
              label: "p4",
              placeholder: "Enter P4",
              name: "change_in_debt_p4",
              type: "text",
              value: ""
            },
            {
              label: "p5",
              placeholder: "Enter P5",
              name: "change_in_debt_p5",
              type: "text",
              value: ""
            },
            {
              label: "p6",
              placeholder: "Enter P6",
              name: "change_in_debt_p6",
              type: "text",
              value: ""
            },
            {
              label: "p7",
              placeholder: "Enter P7",
              name: "change_in_debt_p7",
              type: "text",
              value: ""
            },
            {
              label: "p8",
              placeholder: "Enter P8",
              name: "change_in_debt_p8",
              type: "text",
              value: ""
            },
            {
              label: "p9",
              placeholder: "Enter P9",
              name: "change_in_debt_p9",
              type: "text",
              value: ""
            },
            {
              label: "p10",
              placeholder: "Enter P10",
              name: "change_in_debt_p10",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "investment_made",
          name: "investment_made",
          type: "text",
          reletedField: [
            {
              label: "investment_made_p1",
              placeholder: "Enter P1",
              name: "investment_made_p1",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p2",
              placeholder: "Enter P2",
              name: "investment_made_p2",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p3",
              placeholder: "Enter P3",
              name: "investment_made_p3",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p4",
              placeholder: "Enter P4",
              name: "investment_made_p4",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p5",
              placeholder: "Enter P5",
              name: "investment_made_p5",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p6",
              placeholder: "Enter P6",
              name: "investment_made_p6",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p7",
              placeholder: "Enter P7",
              name: "investment_made_p7",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p8",
              placeholder: "Enter P8",
              name: "investment_made_p8",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p9",
              placeholder: "Enter P9",
              name: "investment_made_p9",
              type: "text",
              value: ""
            },
            {
              label: "investment_made_p10",
              placeholder: "Enter P10",
              name: "investment_made_p10",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "equity_raised",
          name: "equity_raised",
          type: "text",
          reletedField: [
            {
              label: "equity_raised_p1",
              placeholder: "Enter P1",
              name: "equity_raised_p1",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p2",
              placeholder: "Enter P2",
              name: "equity_raised_p2",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p3",
              placeholder: "Enter P3",
              name: "equity_raised_p3",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p4",
              placeholder: "Enter P4",
              name: "equity_raised_p4",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p5",
              placeholder: "Enter P5",
              name: "equity_raised_p5",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p6",
              placeholder: "Enter P6",
              name: "equity_raised_p6",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p7",
              placeholder: "Enter P7",
              name: "equity_raised_p7",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p8",
              placeholder: "Enter P8",
              name: "equity_raised_p8",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p9",
              placeholder: "Enter P9",
              name: "equity_raised_p9",
              type: "text",
              value: ""
            },
            {
              label: "equity_raised_p10",
              placeholder: "Enter P10",
              name: "equity_raised_p10",
              type: "text",
              value: ""
            }
          ]
        }
      ],
      formData: {},
      errors: [],
      defaultSrc: "",
      pType: "projected"
    };
  },
  methods: {
    setData() {
      console.log("Data SEt");
      this.fields = [
        {
          label: "change_in_debt",
          name: "change_in_debt",
          type: "text",
          reletedField: [
            {
              label: "change_in_debt_p1",
              placeholder: "Enter P1",
              name: "change_in_debt_p1",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p1
                : this.defaultSrc
            },
            {
              label: "change_in_debt P2",
              placeholder: "Enter P2",
              name: "change_in_debt_p2",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p2
                : ""
            },
            {
              label: "change_in_debt_p3",
              placeholder: "Enter P3",
              name: "change_in_debt_p3",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p3
                : this.defaultSrc
            },
            {
              label: "change_in_debt P4",
              placeholder: "Enter P4",
              name: "change_in_debt_p4",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p4
                : ""
            },
            {
              label: "change_in_debt_p5",
              placeholder: "Enter P5",
              name: "change_in_debt_p5",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p5
                : this.defaultSrc
            },
            {
              label: "change_in_debt P6",
              placeholder: "Enter P6",
              name: "change_in_debt_p6",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p6
                : ""
            },
            {
              label: "change_in_debt_p7",
              placeholder: "Enter P7",
              name: "change_in_debt_p7",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p7
                : this.defaultSrc
            },
            {
              label: "change_in_debt P8",
              placeholder: "Enter P8",
              name: "change_in_debt_p8",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p8
                : ""
            },
            {
              label: "change_in_debt_p9",
              placeholder: "Enter P9",
              name: "change_in_debt_p9",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p9
                : this.defaultSrc
            },
            {
              label: "change_in_debt P10",
              placeholder: "Enter P10",
              name: "change_in_debt_p10",
              type: "text",
              value: this.globalData.change_in_debt
                ? this.globalData.change_in_debt.p10
                : ""
            }
          ]
        },
        {
          label: "investment_made",
          name: "investment_made",
          type: "text",
          reletedField: [
            {
              label: "investment_made_p1",
              placeholder: "Enter P1",
              name: "investment_made_p1",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p1
                : this.defaultSrc
            },
            {
              label: "investment_made_p2",
              placeholder: "Enter P2",
              name: "investment_made_p2",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p2
                : ""
            },
            {
              label: "investment_made_p3",
              placeholder: "Enter P3",
              name: "investment_made_p3",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p3
                : this.defaultSrc
            },
            {
              label: "investment_made_p4",
              placeholder: "Enter P4",
              name: "investment_made_p4",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p4
                : ""
            },
            {
              label: "investment_made_p5",
              placeholder: "Enter P5",
              name: "investment_made_p5",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p5
                : this.defaultSrc
            },
            {
              label: "investment_made_p6",
              placeholder: "Enter P6",
              name: "investment_made_p6",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p6
                : ""
            },
            {
              label: "investment_made_p7",
              placeholder: "Enter P7",
              name: "investment_made_p7",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p7
                : this.defaultSrc
            },
            {
              label: "investment_made_p8",
              placeholder: "Enter P8",
              name: "investment_made_p8",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p8
                : ""
            },
            {
              label: "investment_made_p9",
              placeholder: "Enter P9",
              name: "investment_made_p9",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p9
                : this.defaultSrc
            },
            {
              label: "investment_made_p10",
              placeholder: "Enter P10",
              name: "investment_made_p10",
              type: "text",
              value: this.globalData.investment_made
                ? this.globalData.investment_made.p10
                : ""
            }
          ]
        },
        {
          label: "equity_raised",
          name: "equity_raised",
          type: "text",
          reletedField: [
            {
              label: "equity_raised_p1",
              placeholder: "Enter P1",
              name: "equity_raised_p1",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p1
                : this.defaultSrc
            },
            {
              label: "equity_raised_p2",
              placeholder: "Enter P2",
              name: "equity_raised_p2",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p2
                : ""
            },
            {
              label: "equity_raised_p3",
              placeholder: "Enter P3",
              name: "equity_raised_p3",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p3
                : this.defaultSrc
            },
            {
              label: "equity_raised_p4",
              placeholder: "Enter P4",
              name: "equity_raised_p4",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p4
                : ""
            },
            {
              label: "equity_raised_p5",
              placeholder: "Enter P5",
              name: "equity_raised_p5",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p5
                : this.defaultSrc
            },
            {
              label: "equity_raised_p6",
              placeholder: "Enter P6",
              name: "equity_raised_p6",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p6
                : ""
            },
            {
              label: "equity_raised_p7",
              placeholder: "Enter P7",
              name: "equity_raised_p7",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p7
                : this.defaultSrc
            },
            {
              label: "equity_raised_p8",
              placeholder: "Enter P8",
              name: "equity_raised_p8",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p8
                : ""
            },
            {
              label: "equity_raised_p9",
              placeholder: "Enter P9",
              name: "equity_raised_p9",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p9
                : this.defaultSrc
            },
            {
              label: "equity_raised_p10",
              placeholder: "Enter P10",
              name: "equity_raised_p10",
              type: "text",
              value: this.globalData.equity_raised
                ? this.globalData.equity_raised.p10
                : ""
            }
          ]
        }
      ];
      console.log(this.globalData.corporate_long_term_interest_rate);
      console.log("Set Value ", this.fields);
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitPData();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    save() {
      this.globalData["update"] = 0;
      this.$refs.smallModal.open();
    },
    updateData() {
      this.globalData["update"] = 1;
      this.$refs.smallModal.open();
    },
    submitPData: function(formData) {
      let myself = this;
      console.log("submit form", this.formData, this.globalData);
      this.getData();
      http.post(
        "updateFinalData/" + this.globalData.co_code,
        this.globalData,
        (error, callback) => {
          // myself.$router.push({ name: "settings" });
          //TODO:: add company updates into our array in future
          if(this.isFromComp === 2){ //From edit form
            this.$toastr.success("Updated Successfully!", "", {});
          } else if(this.isFromComp === 3){ //Form growth tab
            this.$emit('dataupdated', {update: true});
          }
        }
      );
    },
    setFormData() {
      for (var index in this.fields) {
        let field = this.fields[index];
        // console.log(
        //     (field.reletedField.length > 0) + " => Fields Created",
        //     field
        // );
        if (!field.placeholder) field.placeholder = "";
        if (!field.value) field.value = "";
        if (!field.help) field.help = "";
        this.$set(this.formData, field.name, field.value);
        if (field.reletedField.length > 0) {
          // console.log("related");
          let relatedData = field.reletedField;
          for (var ind in relatedData) {
            // console.log(relatedData[ind]);
            let field1 = relatedData[ind];
            // console.log(
            //     "RelatedFields",
            //     field1.value,
            //     field.name,
            //     field1.name,
            //     field1.type
            // );
            if (!field1.placeholder) field1.placeholder = "";
            if (!field1.value) field1.value = "";
            if (!field1.help) field1.help = "";
            if (!field1.type) field1.type = "";
            this.$set(this.formData, field1.name, field1.value, field1.type);
          }
        }
      }
      console.log("this.formData", this.formData);
    },
    getData() {
      console.log(this.globalData);
      let data = {};
      for (let fd in this.fields) {
        let field = this.fields[fd];
        console.log("Field", field.name);
        this.globalData[field.name] = {
          p1: "",
          p2: "",
          p3: "",
          p4: "",
          p5: "",
          p6: "",
          p7: "",
          p8: "",
          p9: "",
          p10: ""
        };
        // this.globalData[field.name].value = this.formData[field.name];
        this.globalData[field.name].p1 = this.formData[field.name + "_p1"];
        this.globalData[field.name].p2 = this.formData[field.name + "_p2"];
        this.globalData[field.name].p3 = this.formData[field.name + "_p3"];
        this.globalData[field.name].p4 = this.formData[field.name + "_p4"];
        this.globalData[field.name].p5 = this.formData[field.name + "_p5"];
        this.globalData[field.name].p6 = this.formData[field.name + "_p6"];
        this.globalData[field.name].p7 = this.formData[field.name + "_p7"];
        this.globalData[field.name].p8 = this.formData[field.name + "_p8"];
        this.globalData[field.name].p9 = this.formData[field.name + "_p9"];
        this.globalData[field.name].p10 = this.formData[field.name + "_p10"];
      }
      console.log(
        "Global Data" + this.globalData,
        JSON.stringify(this.globalData)
      );
    }
  },
  watch: {
    companyData: function(value) {
      // console.log("Sel comp Value", value);
      this.company = value;
      this.globalData = value;
      for (var i in value) {
        // console.log("Callback i", i);
        this[i] = value[i];
      }
      this.setData();
      this.setFormData();
    },
    selCompany: function(value) {
      // console.log("Company Name", value);
      this.compSel = value;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/projected-data.vue